import { TTheme } from '@/core/theme'
import { ActionButton } from '@/ui/components/buttons/action'
import BetaIconPrimary from '@assets/images/beta-icon-primary.svg?react'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    .dashboard-page.fraud-defense {
        margin-top: 36px;
        border-width: 1px;

        .page-actions {
            top: 8px;
        }

        .page-content {
            display: flex;
            flex-direction: column;
            padding: 18px 0 56px 0;
            .title {
                margin-bottom: 36px;
            }

            .benefits-wrapper {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 10%;

                .benefit {
                    display: flex;
                    gap: 24px;
                    flex-direction: column;
                    .benefit-title {
                        color: var(--color-primary-text);
                        margin-bottom: 9px;
                    }

                    .description {
                        color: var(--color-grey-700);
                    }

                    .icon {
                        color: ${({ theme }) => theme.colors.greys[400]};
                    }
                }
            }
            .wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                .joined-the-beta {
                    background-color: var(--color-dark-75);
                    padding: 22px;
                    border-radius: 4px;
                    display: flex;
                    flex-direction: column;
                    justify-self: center;
                    width: fit-content;
                    gap: 16px;
                    margin-top: 55px;
                    .joined-the-beta-content {
                        display: flex;
                        gap: 8px;
                        align-items: center;
                        color: var(--color-grey-600);
                    }
                }
            }
        }
    }
`

export const StyledActionButton = styled(ActionButton)`
    margin-top: 55px;
    align-self: center;
`

export const StyledBetaIconPrimary = styled(BetaIconPrimary)`
    margin-right: 9px;
    font-size: 8px;
    width: 40px;
`
export const TabsRoutingWrapper = styled('div')`
    padding-top: 54px;
    position: relative;
    top: -106px;

    @media screen and (min-width: 1280px) {
        top: 6px;
        padding-top: 16px;
    }
`
